export default {
  marketCodes: {
    id: 'bo_sellers-buyback-opportunities-filters-market-codes',
    defaultMessage: 'Market Codes',
  },
  brand: {
    id: 'bo_sellers-buyback-opportunities-filters-brand',
    defaultMessage: 'Brand',
  },
  categories: {
    id: 'bo_sellers-buyback-opportunities-filters-categories',
    defaultMessage: 'Categories',
  },
  grades: {
    id: 'bo_sellers-buyback-opportunities-filters-grades',
    defaultMessage: 'Grades',
  },
  selectedValues: {
    id: 'bo_sellers-buyback-opportunities-filters-selected-values',
    defaultMessage: '{numberOfSelectedValues} selected',
  },
  reset: {
    id: 'bo_sellers-buyback-opportunities-filters-reset',
    defaultMessage: 'Reset',
  },
  apply: {
    id: 'bo_sellers-buyback-opportunities-filters-apply',
    defaultMessage: 'Apply',
  },
  competitionLevels: {
    id: 'bo_sellers-buyback-opportunities-filters-competition-levels',
    defaultMessage: 'Competition Levels',
  },
}
